<template>
  <div class="payment" v-if="isInit">
    <span class="label">{{ gettext("支付方式") }}</span>
    <div class="select-payment" @click="selectPayment(selectedCard.card_index)">
      <div v-if="hasSelectedCard" class="has-payment">
        <img :src="selectedCard.card_org" class="ic-card" alt="" />
        <span class="card-num">{{
          selectedCard.card_suffix | cardFilter
        }}</span>
      </div>
      <span v-else class="no-payment">{{ gettext("请选择支付方式") }}</span>
      <i class="icon-right"></i>
    </div>
    <Popup
      :isShow="isShowPayList"
      :title="$t('支付方式')"
      @clickMask="isShowPayList = false"
    >
      <div class="popup-wrapper" slot="content">
        <Payment
          v-if="isShowPayList"
          openType="popup"
          @close-popup="isShowPayList = false"
        />
      </div>
    </Popup>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import loginMixin from '@/common/mixin/login'
import { couponPaymethodPopupCk } from '@/page/newCouponsCenter/track'
import Popup from '@/components/vant-popup'
import Payment from '@/page/c/coupon/payment.vue'
export default {
  name: 'PayList',
  mixins: [loginMixin],
  components: {
    Popup,
    Payment
  },
  computed: {
    ...mapGetters(['globalParams', 'selectedCard']),
    hasSelectedCard () {
      return Object.keys(this.selectedCard).length > 0
    },
    extraInfoList () {
      return this.$store.state.extraInfoList
    }
  },
  filters: {
    // 取卡号后4位
    cardFilter (card) {
      return String(card).slice(-4) || ''
    }
  },
  data () {
    return {
      from: 2, // 新券包页面
      isInit: false,
      isShowPayList: false
    }
  },
  async created () {
    this.getInit()
  },
  methods: {
    ...mapActions({
      getGlobalInfo: 'getGlobalInfo',
      setPayment: 'setPayment',
      getPayInfo: 'getPayInfo'
    }),
    getInit () {
      this.getGlobalInfo().then((data) => {
        this.requestPayInfo()
      })
      this.isInit = true
    },
    selectPayment () {
      couponPaymethodPopupCk({ from: this.from })
      this.isShowPayList = true
    },
    async requestPayInfo () {
      // 获取卡信息
      await this.getPayInfo({
        ...this.globalParams
      })
      if (Object.keys(this.selectedCard).length === 0) {
        if (this.extraInfoList.length > 0) {
          // 默认选择第一张卡
          this.setPayment(this.extraInfoList[0])
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.payment {
  margin: 50px 24px;
  display: flex;
  justify-content: space-between;
  color: #333;
  .label {
    font-family: "Aspira Light";
    font-size: 36px;
    color: #000000;
    font-weight: 200;
  }
  .select-payment {
    font-family: "Aspira Regular";
    display: flex;
    align-items: center;
    .has-payment {
      display: flex;
      align-items: center;
    }
    .ic-card {
      width: 70px;
      height: 42px;
      border-radius: 6px;
    }
    .card-num {
      margin-left: 8px;
      width: 81px;
      font-family: "Aspira Medium";
      font-size: 36px;
      color: #000000;
      font-weight: 500;
    }
    .no-payment {
      display: flex;
      align-items: center;
      font-size: 28px;
      color: #ccc;
    }
    .icon-right {
      margin-left: 8px;
      display: inline-block;
      vertical-align: top;
      width: 24px;
      height: 24px;
      background-image: url("~@/assets/images/c/icon-right.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
  }
  .popup-wrapper {
    overflow: hidden;
    margin-top: 43px;
    height: 100%;
    overflow-y: auto;
    border-radius: 12px;
    /deep/ .payment-container {
      position: static;
      display: flex;
      flex-direction: column;
      background: none;
      main {
        border-radius: 12px;
        margin-bottom: 150px;
        background: #fff;
        padding-left: 18px;
      }
      footer {
        position: absolute;
        bottom: 38px;
        width: 702px;
        .btn-wrap {
          margin: 0;
          .rich-btn {
            border-radius: 12px;
          }
        }
      }
      .radio-checked {
 width: 40px;
        height: 40px;
      }
      .radio-no-checked{
        width: 38px;
        height: 38px;
      }
    }
    /deep/ .page-title {
      display: none;
    }
  }
  /deep/ .half-content {
    background: #f3f3f5;
    padding: 38px 24px;
  }
}
</style>
